// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"bbf65f73","773":"9379f271"}[chunkId] + ".chunk.css";
};